import React from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../routes";

/** Catch-all for unknown URLs — a clear message and a way back home. */
const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 items-center justify-center p-4 py-10">
      <div className="flex flex-col items-center text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-grey-95 dark:bg-primary-20">
          <Compass size={32} className="text-grey-40 dark:text-grey-60" />
        </div>
        <h1 className="mt-4 text-grey-10 dark:text-white">{t("notFound.title")}</h1>
        <p className="mt-2 max-w-md text-sm text-grey-30 dark:text-grey-70">
          {t("notFound.description")}
        </p>
        <Link to={ROUTES.HOME_PAGE} className="btn btn-primary mt-6">
          {t("notFound.backHome")}
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
